import React, { useMemo, memo, ReactElement } from "react";

//components
import { BenefitsItemList, BenefitsItemListProps } from "@cart-ui/components/benefits-item-list";

//styles
import styles from "./styles/DelfeeDiscount.scss";

//types
import { RenderingDetails } from "@swiggy-private/cart-types";

//helpers
import { format, isEmpty } from "@swiggy-private/core-ui";

//constants
import { TEXTS } from "@cart-ui/constants";

export interface DelfeeDiscount {
    itemData: RenderingDetails;
}

const AMOUNT = "\u20B9{0}";

function DelfeeDiscount({ itemData }: DelfeeDiscount): ReactElement | null {
    const benefitsList = useMemo(() => {
        const list: BenefitsItemListProps["list"] = [
            {
                title: format(AMOUNT, itemData.value),
                subTitle: TEXTS.DELIVERY_FEE_DISCOUNT,
            },
        ];
        return list;
    }, [itemData]);

    //backend is supposed to handle this check but keeping this check so that UI doesn't break
    if (isEmpty(itemData.value)) {
        return null;
    }

    return (
        <div className={styles.container}>
            <BenefitsItemList list={benefitsList} className={styles.containerContent} />
        </div>
    );
}

export default memo(DelfeeDiscount);
